export default __webpack_public_path__ + "static/media/cross.b86eb11e.svg";